import { useRef, useEffect } from "react";

export default function Page({ title, titleBase = 'BAFTA VIEW', children }) {

  const fullTitle = [title, titleBase]
    .filter(x => x)
    .join(" | ");

  useDocumentTitle(fullTitle);

  return (
      <>{ children }</>
  );
}

function useDocumentTitle(title, keepTitleOnUnmount = false) {
  const defaultTitle = useRef(document.title);

  useEffect(() => {
    document.title = title;
  }, [title]);

  useEffect(() => {
    const cleanUpTitle = defaultTitle.current;
    return () => {
      if (!keepTitleOnUnmount) {
        document.title = cleanUpTitle;
      }
    }
  }, [keepTitleOnUnmount]);
}